import * as VueGoogleMaps from 'vue2-google-maps'

export default function registerGoogleMaps(Vue) {
  /**
   * API KEY: AIzaSyCkI3UY9OOGPU95L6PZ3VFtEi00PDwDMOI
   * In GCP project "Sennder API"
   * https://console.cloud.google.com/apis/credentials/key/102?folder=&organizationId=&project=sennder-api&supportedpurview=project
   **/
  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyCkI3UY9OOGPU95L6PZ3VFtEi00PDwDMOI',
      libraries: 'drawing'
    }
  })
}
